// Team Members Data

import Akash from "../../assets/85532786841.png";
// import Mazahir from "../../assets/85532786842.jpeg";
// import Muzammal from "../../assets/85532786843.jpeg";
import Murtaza from "../../assets/85532786844.png";
// import Akram from "../../assets/85532786845.PNG";
// import Admin from "../../assets/85532786846.jpeg";
// import COO from "../../assets/85532786847.jpeg";
// import CEO from "../../assets/85532786848.jpeg";

// Team Members Data
import CEO from "../../assets/image1.jpeg";
import COO from "../../assets/image2.jpeg";
import Admin from "../../assets/image3.jpeg";
import Mazahir from "../../assets/image5.jpeg";
import Muzammal from "../../assets/image8.jpeg";
import Akram from "../../assets/image6.jpeg";





const TEAM = {
  r1: [
    { name: "Muhammad Asghar Ali Rana", role: "Chief Executive Officer", image: CEO },
    { name: "Muhammad Akbar Ali Rana", role: "Director", image: COO },
  ],
  r2: [
    { name: "Muhammad Shoiab Rana", role: "Admin Manager", image: Admin },
    { name: "Muhammad Akash Anwar", role: "Project Manager", image: Akash },
    { name: "Mazahir Abbas", role: "Compliance Manager", image: Mazahir },
  ],
  r3: [
    { name: "Muhammad Akram", role: "Project Coordinator", image: Akram },
    { name: "Syed Murtaza Ahmed", role: "Submission Manager", image: Murtaza },
    { name: "Muzammal Saleem", role: "Building Layout Analyst", image: Muzammal },
  ],
};

export default TEAM;
